import { Component, OnInit } from '@angular/core';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'app-employer-faq',
  templateUrl: './employer-faq.component.html'
})
export class EmployerFAQComponent implements OnInit {
  chaturl: string ='';

  constructor() {
    this.chaturl = CommonSettings.ChatUrl;
   }

  ngOnInit(): void {
  }

  openChat() {
    window.open(this.chaturl, '', 'width=510, height=900');
  }
}
